import { type FC } from 'react';

import { Outlet } from 'react-router-dom';

import {
  AdminLayoutPage,
  AdminLayoutPageContent,
} from '@/features/admin/AdminLayoutPage';

export const AdminSettingsLayout: FC = () => {
  return (
    <AdminLayoutPage>
      <AdminLayoutPageContent>
        <Outlet />
      </AdminLayoutPageContent>
    </AdminLayoutPage>
  );
};
